<form [formGroup]="formGroup" class="flex gap-4">
  <em-select-operand
    [availableAttributes]="availableAttributes"
    [customAttributes]="customAttributes"
    formControlName="attribute"
    class="w-[300px]"
  >
  </em-select-operand>

  <em-select
    style="max-width: 120px"
    formControlName="operator"
    [label]="'SHARED_LABEL_OPERATOR' | translate"
    [subscriptSizing]="'dynamic'"
  >
    @for (operator of AvailableOperators; track operator) {
      <em-option [value]="operator">
        <div>
          @switch (operator) {
            @case ('plus') {
              <div>+</div>
            }
            @case ('minus') {
              <div>-</div>
            }
            @case ('multiple') {
              <div>*</div>
            }
            @case ('divide') {
              <div>/</div>
            }
            @case ('increase_by_percentage') {
              <div class="flex gap-1">
                <span class="text-success-500">&uarr;</span>%
              </div>
            }
            @case ('decrease_by_percentage') {
              <div class="flex gap-1">
                <span class="text-danger-500">&darr;</span>%
              </div>
            }
          }
        </div>
      </em-option>
    }
    @if (
      operatorValue === 'increase_by_percentage' ||
      operatorValue === 'decrease_by_percentage'
    ) {
      <ng-container emSelectTrigger>
        @if (operatorValue === 'increase_by_percentage') {
          <div class="flex gap-1">
            <span class="text-success-500">&uarr;</span>%
          </div>
        }
        @if (operatorValue === 'decrease_by_percentage') {
          <div class="flex gap-1">
            <span class="text-danger-500">&darr;</span>%
          </div>
        }
      </ng-container>
    }
  </em-select>

  <em-input
    type="number"
    formControlName="value"
    style="max-width: 175px"
    [label]="'SHARED_LABEL_VALUE' | translate"
    [subscriptSizing]="'dynamic'"
  >
    @if (
      operatorValue === 'increase_by_percentage' ||
      operatorValue === 'decrease_by_percentage'
    ) {
      <ng-container emPrefix><em-icon name="percent"></em-icon></ng-container>
    }
  </em-input>

  <em-more-info
    class="mt-4"
    [maxWidth]="400"
    [title]="'MAPPING_ENGINE_CALC_HINT_TITLE' | translate"
    [description]="'MAPPING_ENGINE_CALC_HINT_DESC' | translate"
  >
  </em-more-info>
</form>
